import { api } from '@/config/api';

export type TemplateCategory = 'marketing' | 'utility' | 'authentication';
export type HeaderType = 'NONE' | 'TEXT' | 'IMAGE' | 'VIDEO' | 'DOCUMENT' | 'LOCATION';

export interface TemplateButton {
  type: 'URL' | 'PHONE' | 'QUICK_REPLY' | 'COPY_CODE';
  text: string;
  url?: string;
  phone?: string;
  countryCode?: string;
  payload?: string;
}

export interface TemplateLocation {
  latitude?: number;
  longitude?: number;
  name?: string;
  address?: string;
}

export interface DefaultTemplate {
  _id: string;
  defaultTemplateUid: string;
  title: string;
  description?: string;
  tags: string[];
  thumbnailUrl?: string;
  name: string;
  language: string;
  category: TemplateCategory;
  headerType?: HeaderType;
  headerText?: string;
  headerImageUrl?: string;
  headerVideoUrl?: string;
  headerDocumentUrl?: string;
  headerDocumentFilename?: string;
  headerLocation?: TemplateLocation;
  body: string;
  footer?: string;
  buttons: TemplateButton[];
  previewSamples: Record<string, string>;
  isActive: boolean;
  createdBy: string;
  updatedBy?: string;
  createdAt: string;
  updatedAt: string;
}

export interface ListDefaultTemplatesQuery {
  q?: string;
  category?: TemplateCategory | '';
  page?: number;
  limit?: number;
}

export interface ListDefaultTemplatesResponse {
  items: DefaultTemplate[];
  total: number;
  page: number;
  limit: number;
}

export interface DefaultTemplatePayload {
  title: string;
  description?: string;
  tags?: string[];
  thumbnailUrl?: string;
  name: string;
  language: string;
  category: TemplateCategory;
  headerType?: HeaderType;
  headerText?: string;
  headerImageUrl?: string;
  headerVideoUrl?: string;
  headerDocumentUrl?: string;
  headerDocumentFilename?: string;
  headerLocation?: TemplateLocation;
  body: string;
  footer?: string;
  buttons?: TemplateButton[];
  previewSamples?: Record<string, string>;
  isActive?: boolean;
}

export const defaultTemplatesService = {
  list: async (q: ListDefaultTemplatesQuery): Promise<ListDefaultTemplatesResponse> =>
    (await api.get('/super_admin/default-templates', { params: q })).data,

  get: async (uid: string): Promise<DefaultTemplate> =>
    (await api.get(`/super_admin/default-templates/${uid}`)).data,

  create: async (payload: DefaultTemplatePayload): Promise<DefaultTemplate> =>
    (await api.post('/super_admin/default-templates', payload)).data,

  update: async (uid: string, payload: Partial<DefaultTemplatePayload>): Promise<DefaultTemplate> =>
    (await api.patch(`/super_admin/default-templates/${uid}`, payload)).data,

  remove: async (uid: string): Promise<{ ok: boolean }> =>
    (await api.delete(`/super_admin/default-templates/${uid}`)).data,
};
